import styled from "styled-components";
import H1 from "../../../components/typography/H1";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";

const Wrapper = styled.div`
  padding: 0 20px;
  width: 100%;
  margin: 0px auto;
  box-sizing: border-box;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin-bottom: 40px;

  gap: clamp(0.75rem, (16 / 1920) * 100vw, 1rem);

  h1 {
    margin-bottom: clamp(0.25rem, (8 / 1920) * 100vw, 0.5rem);
  }

  p,
  span {
    font-weight: 300;
    font-size: ${fontSize.s};
  }
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: clamp(3.5rem, (64 / 1920) * 100vw, 4rem);
  align-items: center;

  @media (max-width: 840px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 580px) {
    grid-template-columns: 1fr;
  }
`;

const ContactItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  gap: clamp(0.25rem, (8 / 1920) * 100vw, 0.5rem);
  div {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  h3 {
    letter-spacing: 0.1em;
    font-weight: 300;
    font-size: ${fontSize.m};
  }
  span {
    font-size: ${fontSize.s};
  }
  a {
    position: relative; 
    cursor: pointer;
    color: ${colors.black};
    font-size: ${fontSize.s};
    text-decoration: none;

    &::after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: -4px;
      width: 100%;
      height: 1px;
      background-color: white;
      transform: translateX(-50%) scaleX(0);
      transform-origin: center;
      transition: transform 0.3s ease, background-color 0.3s ease;
    }

    &:hover::after {
      transform: translateX(-50%) scaleX(1);
      background-color: black;
    }
  }

a:link,
a:visited,
a:active {
color: inherit;
text-decoration: none;
}
`;

const contacts = [
  {
    label: "SUPPORT",
    type: "Email",
    value: "support@peakpashmina.com",
    link: "mailto:support@peakpashmina.com",
  },
  {
    label: "CALL",
    type: "Phone",
    value: "+977-9813820652",
    link: "tel:+9779813820652",
  },
  {
    label: "CHAT",
    type: "Whatsapp",
    value: "+977-9813820652",
    link: "https://wa.link/ekdh8w",
  },
  {
    label: "BUSINESS",
    type: "Email",
    value: "business@peakpashmina.com",
    link: "mailto:business@peakpashmina.com",
  },
  {
    label: "MEDIA RELATIONS",
    type: "Email",
    value: "pr@peakpashmina.com",
    link: "mailto:pr@peakpashmina.com",
  },
  {
    label: "COLLABORATIONS",
    type: "Email",
    value: "collab@peakpashmina.com",
    link: "mailto:collab@peakpashmina.com",
  },
];

function ContactSection() {
  return (
    <Wrapper>
      <Header>
        <H1>CONTACT US</H1>
        <p>
          For any of your queries and questions, we invite you to contact the
          respective department, and our team will be pleased to assist you.
        </p>
        <span>Many Thanks,</span>
        <span>Peak Pashmina Team</span>
      </Header>

      <ContactGrid>
        {contacts.map((contact, index) => (
          <ContactItem key={index}>
            <h3 className="label">{contact.label}</h3>
            <div>
              <span>{contact.type}:</span>
              <a href={contact.link}>{contact.value}</a>
            </div>
          </ContactItem>
        ))}
      </ContactGrid>
    </Wrapper>
  );
}

export default ContactSection;
